export default __webpack_public_path__ + "static/media/59-min.e966ee2b.png";